__webpack_require__.S = {};
var initPromises = {};
var initTokens = {};
__webpack_require__.I = (name, initScope) => {
	if(!initScope) initScope = [];
	// handling circular init calls
	var initToken = initTokens[name];
	if(!initToken) initToken = initTokens[name] = {};
	if(initScope.indexOf(initToken) >= 0) return;
	initScope.push(initToken);
	// only runs once
	if(initPromises[name]) return initPromises[name];
	// creates a new share scope if needed
	if(!__webpack_require__.o(__webpack_require__.S, name)) __webpack_require__.S[name] = {};
	// runs all init snippets from all modules reachable
	var scope = __webpack_require__.S[name];
	var warn = (msg) => {
		if (typeof console !== "undefined" && console.warn) console.warn(msg);
	};
	var uniqueName = "dashboard-ui-shell";
	var register = (name, version, factory, eager) => {
		var versions = scope[name] = scope[name] || {};
		var activeVersion = versions[version];
		if(!activeVersion || (!activeVersion.loaded && (!eager != !activeVersion.eager ? eager : uniqueName > activeVersion.from))) versions[version] = { get: factory, from: uniqueName, eager: !!eager };
	};
	var initExternal = (id) => {
		var handleError = (err) => (warn("Initialization of sharing external failed: " + err));
		try {
			var module = __webpack_require__(id);
			if(!module) return;
			var initFn = (module) => (module && module.init && module.init(__webpack_require__.S[name], initScope))
			if(module.then) return promises.push(module.then(initFn, handleError));
			var initResult = initFn(module);
			if(initResult && initResult.then) return promises.push(initResult['catch'](handleError));
		} catch(err) { handleError(err); }
	}
	var promises = [];
	switch(name) {
		case "default": {
			register("@xendit/ui-toolkit", "1.0.0-rc19", () => (Promise.all([__webpack_require__.e(1044), __webpack_require__.e(6072), __webpack_require__.e(2646), __webpack_require__.e(7513), __webpack_require__.e(8481)]).then(() => (() => (__webpack_require__(83330))))));
			register("@xendit/xendit-design-system", "0.26.1", () => (Promise.all([__webpack_require__.e(8687), __webpack_require__.e(6072), __webpack_require__.e(2646)]).then(() => (() => (__webpack_require__(68687))))));
			register("i18next", "23.16.8", () => (__webpack_require__.e(3918).then(() => (() => (__webpack_require__(3918))))));
			register("react-dom", "18.3.1", () => (Promise.all([__webpack_require__.e(2354), __webpack_require__.e(6072)]).then(() => (() => (__webpack_require__(82354))))));
			register("react-google-recaptcha", "2.1.0", () => (Promise.all([__webpack_require__.e(6072), __webpack_require__.e(5333)]).then(() => (() => (__webpack_require__(47714))))));
			register("react-i18next", "14.1.3", () => (Promise.all([__webpack_require__.e(7054), __webpack_require__.e(6072)]).then(() => (() => (__webpack_require__(37054))))));
			register("react-redux", "9.1.2", () => (Promise.all([__webpack_require__.e(4543), __webpack_require__.e(6072)]).then(() => (() => (__webpack_require__(84543))))));
			register("react-router-dom", "5.2.0", () => (Promise.all([__webpack_require__.e(7187), __webpack_require__.e(6072), __webpack_require__.e(7499)]).then(() => (() => (__webpack_require__(77187))))));
			register("react", "18.3.1", () => (__webpack_require__.e(6087).then(() => (() => (__webpack_require__(36087))))));
			register("redux", "5.0.1", () => (__webpack_require__.e(2199).then(() => (() => (__webpack_require__(32199))))));
			register("styled-components", "4.4.1", () => (Promise.all([__webpack_require__.e(639), __webpack_require__.e(6072), __webpack_require__.e(305)]).then(() => (() => (__webpack_require__(10639))))));
		}
		break;
	}
	if(!promises.length) return initPromises[name] = 1;
	return initPromises[name] = Promise.all(promises).then(() => (initPromises[name] = 1));
};